import React from "react";
import { Switch } from "@/components/ui/switch";

export const KIA_GRIDS = [
  { value: "PLIB", label: "Grille 1" }, { value: "KIA_LEASE", label: "Grille 2 · Kia Lease" },
  { value: "LLD", label: "Grille 3 · LLD / Grands comptes" }, { value: "GRILLE_4", label: "Grille 4" },
  { value: "LCD", label: "Grille 5 · Loueurs courte durée" }, { value: "TAXI", label: "Grille 6 · Taxi / VTC / VSL" },
];
const fr = (value) => Number(value).toLocaleString("fr-FR", { maximumFractionDigits: 2 });

export const KiaConditionsPanel = ({ model, form, onChange }) => {
  const plan = model.kia_conditions;
  const company = form.company_type !== "NON";
  const total = model.company_rates?.[form.company_type];
  const recommended = plan.recommended_company_discounts?.[form.company_type];
  const context = form.kia_context || {};
  const updateContext = (key, value) => onChange("kia_context", { ...context, [key]: value });
  const vdr = form.is_vdr_sale;
  const vd = form.is_vd_sale;
  const prime = form.has_kialiberty ? model.kialiberty_prime : model.systematic_prime;
  return (
    <section data-testid="kia-conditions-panel" className="mt-4 border-t pt-4 space-y-3">
      <h3 data-testid="kia-conditions-title" className="text-sm font-semibold">Kia · {plan.period}</h3>
      {company ? <p data-testid="kia-company-rule" className="text-sm">
        {total === undefined ? "Grille non renseignée pour ce modèle ou finition exclue." : <>
          Base {fr(model.base_margin_rate * 100)} % + support KFR {fr((total - model.base_margin_rate) * 100)} % = <strong>{fr(total * 100)} % au total</strong>.
          {recommended !== undefined && ` Remise de référence : ${fr(recommended * 100)} %.`}
        </>}
      </p> : vdr ? <p data-testid="kia-vdr-rule" className="text-sm text-muted-foreground">Conditions VDR antérieures conservées ; la nouvelle grille de mise à la route concerne les VD VP.</p> : <>
        <div className="flex items-center justify-between gap-3">
          <label htmlFor="kia-oct-liberty" data-testid="kia-liberty-label" className="text-sm font-medium">KiaLiberty [12]</label>
          <Switch id="kia-oct-liberty" data-testid="kia-liberty-switch" checked={form.has_kialiberty} onCheckedChange={(value) => onChange("has_kialiberty", value)} />
        </div>
        <p data-testid="kia-private-rule" className="text-sm text-muted-foreground">
          {plan.light_excluded ? "EV2 Light : marge de base 9 %, sans prime KFR ni grille société." :
            `Participation KFR ${form.has_kialiberty ? "[12]" : "[11]"} : ${fr(prime || 0)} € HT. Remise client de référence : ${fr(plan.customer_discount_ttc)} € TTC.`}
          {plan.retail_codes.length === 1 && " Aide principale réservée au code [12] dans le document."}
          {vd && " VD VP : base + prime applicable + 3 %."}
        </p>
        {!vd && model.trade_in_bonus > 0 && <>
          <div className="flex items-center justify-between gap-3 border-t pt-3">
            <label htmlFor="kia-oct-trade" data-testid="kia-trade-label" className="text-sm">Reprise éligible · +{fr(model.trade_in_bonus)} € HT</label>
            <Switch id="kia-oct-trade" data-testid="kia-trade-switch" checked={form.has_trade_in} onCheckedChange={(value) => onChange("has_trade_in", value)} />
          </div>
          {form.has_kialiberty && <div className="flex items-center justify-between gap-3">
            <label htmlFor="kia-oct-renewal" data-testid="kia-renewal-label" className="text-sm">Renouvellement d’un KiaLiberty existant</label>
            <Switch id="kia-oct-renewal" data-testid="kia-renewal-switch" checked={!!context.liberty_renewal} onCheckedChange={(v) => updateContext("liberty_renewal", v)} />
          </div>}
          <p data-testid="kia-trade-rule" className="text-xs text-muted-foreground">Reprise ou renouvellement KiaLiberty : une seule prime de {fr(model.trade_in_bonus)} € HT. Remise reprise de référence : {fr(plan.trade_customer_discount_ttc)} € TTC.</p>
        </>}
      </>}
      {plan.stock_or_planned_only && !vd && !vdr && <>
        <p data-testid="kia-stock-restriction" className="text-xs text-muted-foreground">Offre réservée au stock ou à la production planifiée.</p>
        {form.sale_type !== "STOCK" && <div className="flex items-center justify-between gap-3">
          <label htmlFor="kia-oct-production" data-testid="kia-production-label" className="text-sm">Production planifiée confirmée</label>
          <Switch id="kia-oct-production" data-testid="kia-production-switch" checked={!!context.production_planned} onCheckedChange={(v) => updateContext("production_planned", v)} />
        </div>}
      </>}
    </section>
  );
};